import { Injectable } from '@angular/core';
import { CustomerListConfigService, Customer, UsersService, AuthService } from 'gung-standard';
import { RefCustomerService } from '../ref-customer/ref-customer.service';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { environment } from '../../../environments/environment';
import { CapstoneCustomerListCardComponent } from '../../components/capstone/capstone-customer-list-card/capstone-customer-list-card.component';

@Injectable({
  providedIn: 'root'
})
export class RefCustomerListConfigService extends CustomerListConfigService {
  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CapstoneCustomerListCardComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Customer list'
      }
    ];
  }
}
